import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import {translate} from 'react-i18next';

var Config = require('../../../config');

class ModalSend extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			table_units:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_delivered/by_petition?id='+id+
			'&hf_id='+sessionStorage.getItem('health_facilities_id'),{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					table_units:[],
				});
				response.units_delivered.map((res, i)=>{
					this.setState({
						table_units: [
							...this.state.table_units,
							{
								folio:res.folio,
								unit_id:res.unit.id,
								unit: res.unit.unit_number,
								component: res.component,
								component_number: res.unit.component_number,
								received_by: res.received_by,
								facility_sections_name: res.facility_sections_name,
								delete: false,
								id:res.unit_delivered_id,
							}
						],
					});
				})
			}
		})
		this.setState({show:true});
	}

	handleClose(){
		this.setState({show:false});
	}

	render(){
		const {t} = this.props;
		return(
			<Modal bsSize="lg" backdrop="static" keyboard={false} dialogClassName="modal-samples" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Datos de envio</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<Table responsive hover>	
		        				<thead>
		        					<tr>
		        						<th>Folio</th>
		        						<th>Unidad</th>
		        						<th>Componente</th>
		        						<th>Numero Componente</th>
		        						<th>Entregado a</th>
		        						<th>Destino</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.table_units.map((t, i)=>(
		        						<tr key={i}>
											<td>{t.folio}</td>
											<td>{t.unit}</td>
											<td>{t.component}</td>
											<td>{t.component_number}</td>
											<td>{t.received_by}</td>
											<td>{t.facility_sections_name}</td>
										</tr>
									))}
		        				</tbody>
		        			</Table>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{/*<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.onSave} 
		        	disabled={this.state.disableSave} />*/}
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}

}
export default translate('translations')(ModalSend);